// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__12L0H","boxTitle":"Qualiphy_boxTitle__hAHQv","box":"Qualiphy_box__MjPZI","toggleWrap":"Qualiphy_toggleWrap__3UUj_"};